/**************************************************
 * 
 * Global QMod Component Changes
 * 
 * These are temporary hotfixes until QMod makes official updates.
 * 
 **************************************************/

/**
 * Function to delay execution by a given time in milliseconds.
 */
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// Store functions that need to be run anytime a screen resize occurs
let qmodResizeEvents = {};
function qmodResize() {
    for(func in qmodResizeEvents) {
        qmodResizeEvents[func]();
    }
}

/**
 * Page Type: QMod - Chart, Quote & Historical 
 * 
 * Assigns unique aria-labels to highcharts containers.
 * 
 * @since QMod v1.69.0
 */
function assignUniqueAriaLabels() {
    const charts = jq('[id^=highcharts-].highcharts-container');
    charts.each(function (index) {
        const uniqueLabel = `Chart Container ${index + 1}`;
        jq(this).attr("aria-label", uniqueLabel);
    });
}

/**
 * Page Type: QMod - Chart, Quote & Historical 
 * 
 * Assigns unique IDs to duplicate filters within SVG defs.
 * 
 * @since QMod v1.69.0
 */
function assignUniqueFilterIds() {
    const filters = jq('svg defs filter[id="highcharts-drop-shadow-0"]');
    filters.each(function (index) {
        if (index > 0) {
            const newId = `highcharts-drop-shadow-${Math.random().toString(36).substr(2, 9)}`;
            jq(this).attr('id', newId);

            // Update any references to this filter id in the SVG
            const references = jq(`svg [filter="url(#highcharts-drop-shadow-0)"]`);
            references.each(function () {
                jq(this).attr('filter', `url(#${newId})`);
            });
        }
    });
}

// Call the toggleTabIndex on initial load after delay
qmodResizeEvents.fixRoles = function() {
    observeForContent('[id^=highcharts-].highcharts-container')
        .then((evt) => {    
            toggleTabIndex(null, true);
            jq('[id^=highcharts-].highcharts-container').attr("role", "region");
            assignUniqueAriaLabels();
            assignUniqueFilterIds();
        });
    observeForContent('[id^=highcharts-end-of-chart-marker-]')
        .then((evt) => {
            jq('[id^=highcharts-end-of-chart-marker-]').attr("role", "region"); 
        });
}

/**
 * Page Type: QMod - Chart, Quote & Historical 
 * 
 * Fixes the unique ID and missing aria attributes.
 * 
 * @since QMod v1.69.0
 */
qmodResizeEvents.assignUniqueAttributes = function() {
    // Function to generate a unique ID
    function generateUniqueId(baseId) {
        return baseId + '-' + Math.random().toString(36).substr(2, 9);
    }

    // Select all elements with duplicate IDs
    const ids = [
        'highcharts-end-of-chart-marker-0',
        'highcharts-screen-reader-region-before-0',
        'highcharts-drop-shadow-0',
        'highcharts-screen-reader-region-after-0',
        'highcharts-2ih7fo0-0',
        'highcharts-fjy84ra-0'
    ];

    ids.forEach((baseId) => {
        const elements = document.querySelectorAll(`#${baseId}`);
        elements.forEach((element, index) => {
            if (index > 0) {
                const newId = generateUniqueId(baseId);
                element.setAttribute('id', newId);
            }
        });
    });

    // Ensure unique aria-label for landmarks
    observeForContent('.highcharts-container')
        .then(() => {
            const landmarkElements = document.querySelectorAll('.highcharts-container');
            landmarkElements.forEach((element, index) => {
                if (!element.getAttribute('aria-label')) {
                    element.setAttribute('aria-label', `Unique Chart ${index + 1}`);
                }
            });
        });

    // Fix duplicate filter ids within SVG defs
    observeForContent('svg defs filter[id="highcharts-drop-shadow-0"]')
        .then(() => {
            const filters = document.querySelectorAll('svg defs filter[id="highcharts-drop-shadow-0"]');
            filters.forEach((filter, index) => {
                if (index > 0) {
                    const newId = generateUniqueId('highcharts-drop-shadow-0');
                    filter.setAttribute('id', newId);

                    // Update any references to this filter id in the SVG
                    const references = document.querySelectorAll(`svg [filter="url(#highcharts-drop-shadow-0)"]`);
                    references.forEach((reference) => {
                        jq(reference).attr('filter', `url(#${newId})`);
                    });
                }
            });
        });

    // Ensure unique aria-labels for specific elements
    const specificElements = ['highcharts-3yiiuel-0', 'highcharts-pu44erb-0'];
    specificElements.forEach((baseId, index) => {
        const element = document.querySelector(`#${baseId}`);
        if (element && !element.getAttribute('aria-label')) {
            element.setAttribute('aria-label', `Unique Chart Specific ${index + 1}`);
        }
    });
}

/**
 * Page Type: QMod - Historical Data
 * 
 * Creates and inserts a label for an input selected by a specific CSS selector.
 * 
 * @since QMod v1.69.0
 */
function createLabelForInputBySelector(selector, labelText) {
    let inputElement = document.querySelector(selector);
    if (!inputElement) {
        return;
    }

    let inputId = 'input-' + Math.random().toString(36).substr(2, 9);
    inputElement.id = inputId;

    let label = document.createElement('label');
    label.htmlFor = inputId;
    label.textContent = labelText;
    label.classList.add("sr-only");

    inputElement.parentNode.insertBefore(label, inputElement);
}

// Create and insert labels using the specific QMod selectors after delay
delay(2000).then(() => {
    createLabelForInputBySelector('#qmod-fromdate > div > div.duet-date__input-wrapper > input.duet-date__input', 'From date');
    createLabelForInputBySelector('#qmod-todate > div > div.duet-date__input-wrapper > input.duet-date__input', 'To date');
});

/**
 * Page Type: QMod - Historical Data
 * 
 * Adds a span element with class "sr-only" to all matching th elements.
 * 
 * @since QMod v1.69.0
 */
function addSrOnlySpanToThElements() {
    // Select all th QMod elements with the specified class
    let thElements = document.querySelectorAll('th.qmod-control.control.sorting_disabled.dtr-hidden');

    // Iterate over each th element
    thElements.forEach(function(th) {
        // Check if there's already an sr-only span, if not, add one
        if (!th.querySelector('.sr-only')) {
            let span = document.createElement('span');
            span.className = 'sr-only';
            span.textContent = 'Control Header';
            span.setAttribute('aria-hidden', 'true');
    
            th.appendChild(span);
        }
    });
}

// Call the SR Only Function after delay
delay(2000).then(() => {
    addSrOnlySpanToThElements();
});

/**
 * Observes for content and resolves the promise once content is found.
 */
function observeForContent(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

/**
 * Page Type: QMod - Historical Data
 * 
 * QMOD table header SR issue fix for sorting headers.
 * 
 * @since QMod v1.69.0
 */
if (jq('body').hasClass('page-type-qmod---historical-data')) {
    observeForContent('#qmod-price-history').then(() => {
        // Append sr-only caption to table
        let $historyTable = jq('#qmod-price-history');
        $historyTable.prepend('<caption class="sr-only">Column headers are sortable.</caption>');
        
        // Remove aria-labels on sorting headers
        $historyTable.find('th.sorting').each(function() {
            jq(this).removeAttr('aria-label');
            // Remove aria-labels again on click, as they get added by qmod
            jq(this).accessibleClick(function (e) {
                jq('#qmod-price-history th.sorting').removeAttr('aria-label');
            });
        });
    });
}

/**
 * Global for all QMod Components with Legends
 * 
 * Sets tabindex and accessible click for .qmod-legend li elements.
 */
delay(1000).then(() => {
    jq('.qmod-legend li').each(function(i) {
        jq(this).attr('tabindex', 0);
        jq(this).accessibleClick(function(evt) {
            // We want to use the accessibleClick method so that the logic surrounding
            // keys is consistent; However, avoid recursion by causing an infinite click loop
            if (evt.type != 'click') {
                jq(this).click();
                return false;
            }
        });
    });
});

/**
 * Global for all QMod Components with Main Chart
 * 
 * Fixes the unique label for qmod-main-chart.
 */
function assignUniqueLabels() {
    return new Promise((resolve) => {
        setTimeout(() => {
            const elements = document.querySelectorAll('.qmod-main-chart');

            elements.forEach((element, index) => {
                // Check if the element already has a unique aria-label
                if (!element.getAttribute('aria-label')) {
                    element.setAttribute('aria-label', `Unique Chart ${index + 1}`);
                }
            });

            resolve();
        }, 2000); // 2-second delay
    });
}

// Call the function after the DOM has fully loaded
document.addEventListener('DOMContentLoaded', () => {
    assignUniqueLabels();
});

/**
 * Page Type: QMod - Dividends
 * 
 * Fixes invalid ARIA attribute names.
 * 
 * @since QMod v1.69.0
 */
function fixInvalidAriaAttributes() {
    return new Promise((resolve) => {
        setTimeout(() => {
            const invalidAriaElements = document.querySelectorAll('[aria-role]');
            
            invalidAriaElements.forEach(element => {
                // Get the value of the incorrect aria-role attribute
                const ariaRoleValue = element.getAttribute('aria-role');
                
                // Remove the incorrect aria-role attribute
                element.removeAttribute('aria-role');
                
                // Set the correct role attribute
                element.setAttribute('role', ariaRoleValue);
            });

            resolve();
        }, 2000); // 2-second delay
    });
}

// Call the function after the DOM has fully loaded
document.addEventListener('DOMContentLoaded', () => {
    fixInvalidAriaAttributes();
});

/**
 * Page Type: QMod - Chart, Quote & Historical 
 * 
 * Toggles the tabindex and aria-hidden attributes of elements in the tab panels 
 * to prevent tabbing into hidden fields.
 * 
 * @since QMod v1.69.0
 */
function toggleTabIndex(event, isFirstLoad = false) {
    let next, previous;
    if (!isFirstLoad) {
        next = jq(event.target.hash);
        previous = jq(event.relatedTarget.hash);
    } else {
        next = jq('#tab_quote');
        previous = jq('#tab_historical');
    }

    // Add aria-hidden="true" and tabindex="-1" to the hidden tab-panel
    previous.attr('aria-hidden', 'true');
    previous.find('input, button:not(.no-tab), th.sorting, .qmod-calendar-control, .highcharts-container, .qmod-a11y-toggle-wrap, .qmod-a11y-dropdown2-combobox, .highcharts-exit-anchor').attr('tabindex', '-1');
    previous.find('.highcharts-exit-anchor').attr('aria-hidden', 'true');

    // Remove aria-hidden and set tabindex="0" from the active tab-panel
    next.removeAttr('aria-hidden');
    next.find('input, button:not(.no-tab), th.sorting, .qmod-calendar-control, .highcharts-container, .qmod-a11y-toggle-wrap, .qmod-a11y-dropdown2-combobox, .highcharts-exit-anchor').attr('tabindex', '0');
    next.find('.highcharts-exit-anchor').attr('aria-hidden', 'false');
}

// Update table inputs on tab click
jq('.stock-tab a[data-toggle="tab"]').on('shown.bs.tab', function (event) {
    toggleTabIndex(event, false);
});

// Initial load adjustments
delay(2000).then(() => {
    toggleTabIndex(null, true);
});

/**
 * Ensure dropdown in historical data pane opens on Enter key press
 */
jq(document).on('keydown', '.qmod-a11y-dropdown2', function (event) {
    if (event.key === 'Enter') {
        let expanded = jq(this).attr('aria-expanded') === 'true';
        jq(this).attr('aria-expanded', !expanded);
        jq(this).click();
    }
});

/**
 * Page Type: QMod - Chart, Quote & Historical 
 * 
 * Ensures that down and up arrow icons are not hidden and have the appropriate aria-labels.
 */
function setAriaLabelsForIcons() {
    const downArrowIcon = jq('.qmod-change.qmod-ch-down .qmod-change-icon.fa.fa-arrow-circle-down');
    const upArrowIcon = jq('.qmod-change.qmod-ch-up .qmod-change-icon.fa.fa-arrow-circle-up');

    if (downArrowIcon.length > 0) {
        downArrowIcon.attr('aria-hidden', 'false');
        downArrowIcon.attr('aria-label', 'Down');
        downArrowIcon.attr('role', 'img');
        downArrowIcon.removeAttr('aria-disabled');
    }

    if (upArrowIcon.length > 0) {
        upArrowIcon.attr('aria-hidden', 'false');
        upArrowIcon.attr('aria-label', 'Up');
        upArrowIcon.attr('role', 'img');
        upArrowIcon.removeAttr('aria-disabled');
    }
}

// Call the function with a delay after the DOM has fully loaded
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        setAriaLabelsForIcons();
    }, 2000); // 2-second delay
});

/**
 * Page Type: QMod - Dividends
 * 
 * Wraps the pagination in a nav element with class "pagination-wrapper" and 
 * sets appropriate aria-labels for the nav and pagination buttons.
 */
function enhancePaginationAccessibility(pagination) {
    if (pagination && !pagination.dataset.a11yEnhanced) {
        pagination.dataset.a11yEnhanced = 'true';

        // Create a nav element with the class "pagination-wrapper" and aria-label "Pagination"
        const navWrapper = document.createElement('nav');
        navWrapper.classList.add('pagination-wrapper');
        navWrapper.setAttribute('aria-label', 'Pagination');

        // Wrap the pagination element with the nav element
        pagination.parentNode.insertBefore(navWrapper, pagination);
        navWrapper.appendChild(pagination);

        // Function to set aria-labels for the next and previous buttons
        const setAriaLabels = () => {
            const prevButton = pagination.querySelector('.previous');
            const nextButton = pagination.querySelector('.next');
            
            if (prevButton) {
                prevButton.setAttribute('aria-label', 'Previous Page');
                // Fixes aria-prohibited-attr violation
                prevButton.setAttribute('role', 'link');
            }
            
            if (nextButton) {
                nextButton.setAttribute('aria-label', 'Next Page');
                // Fixes aria-prohibited-attr violation
                nextButton.setAttribute('role', 'link');
            }

            // Set aria-current="page" for the active page
            const pageButtons = pagination.querySelectorAll('.paginate_button');
            pageButtons.forEach(button => {
                if (button.classList.contains('current')) {
                    button.setAttribute('aria-current', 'page');
                } else {
                    button.removeAttribute('aria-current');
                }
                // QMod emits "aria-role", which is not a valid ARIA attribute.
                // Promote it to a real role so the links stay announced as links.
                const invalidRole = button.getAttribute('aria-role');
                if (invalidRole) {
                    button.removeAttribute('aria-role');
                    if (!button.hasAttribute('role')) {
                        button.setAttribute('role', invalidRole);
                    }
                }
            });
            
            // Add aria labels to ellipses
            const ellipses = pagination.querySelectorAll('.ellipsis');
            ellipses.forEach(ellipsis => {
                ellipsis.setAttribute('aria-label', 'Ellipsis indicating non-visible pages');  
            });
        };

        // Apply aria-labels initially
        setAriaLabels();

        // MutationObserver to watch for changes in the pagination element
        const observer = new MutationObserver(setAriaLabels);
        observer.observe(pagination, { childList: true, subtree: true });
    }
}

// Call the function with a delay after the DOM has fully loaded
document.addEventListener('DOMContentLoaded', () => {
    observeForContent('.dataTables_paginate')
        .then(() => {
            document.querySelectorAll('.dataTables_paginate').forEach(enhancePaginationAccessibility);
        });
});

/**
 * Page Type: QMod - Chart, Quote & Historical 
 * 
 * Adds meaningful aria-label to empty table headers.
 * 
 * @since QMod v1.69.0
 */
function fixEmptyTableHeaders() {
    return new Promise((resolve) => {
        setTimeout(() => {
            const emptyHeaders = document.querySelectorAll('th.qmod-control.control.sorting_disabled[aria-label=""]');
            emptyHeaders.forEach(header => {
                header.setAttribute('aria-label', 'Empty header');
            });
            resolve();
        }, 2000); // 2-second delay
    });
}

// Call the function after the DOM has fully loaded
document.addEventListener('DOMContentLoaded', () => {
    fixEmptyTableHeaders();
});

/**
 * Page Type: QMod - Chart, Quote & Historical 
 * 
 * Adds a valid role to .qmod-a11y-toggle-wrap.qmod-volume-toggle elements.
 * 
 * @since QMod v1.69.0
 */
function addTabIndexToVolumeToggle() {
    return new Promise((resolve) => {
        setTimeout(() => {
            const toggleWrapElements = document.querySelectorAll('.qmod-a11y-toggle-wrap.qmod-volume-toggle');
            toggleWrapElements.forEach(element => {
                element.setAttribute('tabindex', '-1');
            });
            resolve();
        }, 2000); // 2-second delay
    });
}

// Call the function after the DOM has fully loaded
document.addEventListener('DOMContentLoaded', () => {
    addTabIndexToVolumeToggle();
    qmodResize();
    window.addEventListener("resize", qmodResize);
});

setInterval(() => {
    const landmarkElements = document.querySelectorAll('.highcharts-exit-anchor');
    if (landmarkElements) {
        landmarkElements.forEach((element, index) => {
            if (!element.getAttribute('aria-label')) {
                element.setAttribute('role', 'region');
                element.setAttribute('aria-label', `Unique Chart ${index + 1}`);
            }
        });
    }
}, 500);

setInterval(() => {
    const hiddenElements = document.querySelectorAll('.dtr-hidden');
    if (hiddenElements) {
        hiddenElements.forEach(element => {
            element.remove();
        });
    }
}, 500);